// Cache over fetchFileVersions (GET /ideal-studio-files/versions).
//
// A file's version family is the same list whichever member you ask with, so a
// fetch is stored under the requested url AND every member's url (and mp4Url).
// That lets a modal that opens on a different member of the same family — the
// Görseli Düzenle (AreaOpsModal) History right after the Animate Image popup
// fetched the family — render it on its first frame instead of popping rows in
// when the request lands. Also kept in localStorage so a reopen after a reload
// is instant too. Callers still refetch to stay fresh.
import { fetchFileVersions } from "../../common/server_utils";

const STORAGE_PREFIX = "file-versions:";
const cache = new Map();
const keyOf = (url) => (url || "").split("?")[0];

function store(key, arr) {
  cache.set(key, arr);
  try {
    localStorage.setItem(STORAGE_PREFIX + key, JSON.stringify(arr));
  } catch (_) {
    /* quota / private mode — the in-memory copy still serves this session */
  }
}

export function getCachedFileVersions(url) {
  if (!url) return null;
  const key = keyOf(url);
  if (cache.has(key)) return cache.get(key);
  try {
    const raw = localStorage.getItem(STORAGE_PREFIX + key);
    const arr = raw ? JSON.parse(raw) : null;
    if (Array.isArray(arr)) {
      cache.set(key, arr);
      return arr;
    }
  } catch (_) {
    /* unreadable entry — treat as a miss */
  }
  return null;
}

export async function fetchFileVersionsCached(url) {
  const list = await fetchFileVersions(url);
  const arr = Array.isArray(list) ? list : [];
  if (arr.length) {
    const keys = new Set([keyOf(url)]);
    arr.forEach((v) => {
      if (v?.fileVirtualPath) keys.add(keyOf(v.fileVirtualPath));
      if (v?.mp4Url) keys.add(keyOf(v.mp4Url));
    });
    keys.forEach((k) => store(k, arr));
  }
  return arr;
}

// Tests only.
export function clearFileVersionsCache() {
  cache.clear();
}
